import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import PayementIframe from './components/PayementIframe';

import { InfoBox, Card } from 'hosman-material';

import { createPhotoMeeting } from '../../../../../../../../../reducers/SellerApp/photoMeetingsSlice';

const Paiement = () => {
  const { sale } = useSelector((state) => state.sellerSales);
  const { newPhotoMeetingParams: { formValues }, photoPacks: { lightshop_fee } } = useSelector((state) => state.sellerPhotoMeetings);
  const [payementDone, setPayementDone] = useState(false)
  const dispatch = useDispatch();

  useEffect(() => {
    if (!payementDone) return;
    
    dispatch(createPhotoMeeting({ saleId: sale.id, params: { ...formValues, contact_name: `${formValues.contact_name} ${formValues.last_name}`} }));
  }, [payementDone]);

  return (
    <div className='flex flex-col gap-6'>
      <p className='h2'>Souscription à la prestation</p>

      <InfoBox avatarSrc={sale.expert?.user?.profile_pic_url}>
        <div>
          <p>Vous ne serez débité qu'une fois la réservation effectuée et le rendez-vous confirmé.</p>
          <p className='font-semibold'>Le reportage photo est inclus dans le service Hosman :</p>
          <p className='font-semibold'>il ne vous est pas facturé. Vous ne payez que pour les diagnostics.</p>
        </div>
      </InfoBox>

      <div className='flex flex-col-reverse md:flex-row items-center gap-6'>
        <PayementIframe payementDone={payementDone} setPayementDone={setPayementDone} />

        <div className='md:w-2/5'>
          <Card classes='flex flex-col gap-3 text-center items-center'>
            <div className='border-b-2 border-ih-blue-30'>
              <p className='h2 p-6'>Panier</p>
            </div>

            <div className='p-6'>
              <p>Diagnostics Complets</p>
              <p className='text-ih-indigo-50 font-light'>(Loi Carrez, DPE, ERP, Electricité, Gaz, Plomb, Amiante, Termites)</p>

              <div className='bg-ih-indigo-5 border rounded-3xl w-max mx-auto p-3 mt-8'>
                <p>Prix de la prestation</p>
                <p className='h2'>{lightshop_fee?.toLocaleString()} €</p>
              </div>
            </div>
          </Card>
        </div>
      </div>

      <InfoBox>
        <p>Paiement 100% sécurisé, aucune donnée bancaire n'est 
        stockée sur nos serveurs et toutes les données sont cryptées.</p>
      </InfoBox>
    </div>
  )
}

export default Paiement;
